import {
  fetchRecommendationsFulfilled,
  fetchRecommendationsPending,
  fetchRecommendationsRejected,
} from '../../actions/recommendations';
import { prepareRecommendations } from '../../mappers/prepareRecommendations';
import {
  TGetFavoritesRecommendationsResponse,
  fetchGetFavoritesRecommendations,
} from '../../repositories/favorites/v1/get-favorites-recommendations';
import { TThunkAction } from '../../types/redux';

const INITIAL_PAGE = 0;

const DEGRADATION_TELEMETRY_KEY = 'degradation.getFavoritesRecommendations';

export const getRecommendations =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger, telemetry }) => {
    dispatch(fetchRecommendationsPending());

    try {
      const { statusCode, response }: TGetFavoritesRecommendationsResponse = await fetchGetFavoritesRecommendations({
        httpApi,
        parameters: {
          page: INITIAL_PAGE,
          category: 'all',
        },
      });

      if (statusCode === 200) {
        dispatch(
          fetchRecommendationsFulfilled({
            data: prepareRecommendations(response.items),
            hasMore: !!response.canLoadMore,
          }),
        );
      }

      if (statusCode === 400) {
        dispatch(fetchRecommendationsRejected());

        telemetry.increment(DEGRADATION_TELEMETRY_KEY);
        logger.warning(response.message || 'Failed to get Recommendations (400 status code)');
      }
    } catch (e) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      dispatch(fetchRecommendationsRejected());

      logger.error(e, { description: 'Failed to get Recommendations' });
    }
  };
